
import { type CSSProperties } from 'react';

export function Loader(props: { size?: 'xsm' | 'sm' | 'md' | 'lg', style?: CSSProperties}) {
  return (
    <div className="loader" style={{...props.style}}>
      <div className={`loader-spinner loader-${props.size}`}></div>
    </div>
  );
}
